module.exports = __webpack_public_path__ + "media/images/global/icons/hairmake-f574b8c11f9484bd3c25015db4f6a96e.svg";